// Material Kit 2 React base styles
import colors from "../../base/colors";

const { text } = colors;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  styleOverrides: {
    root: {
      color: text.main,
    },
  },
};
